import React, { useCallback, useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import { ButtonBase } from '@material-ui/core'
import ArrowDropdownDown from 'components/common/icons/ArrowDropdownDown'
import ArrowDropdownUp from 'components/common/icons/ArrowDropdownUp'
import GrinMenu from 'components/common/menu/GrinMenu'
import GenericOptionMenuItem from './GenericOptionMenuItem'

const useStyles = makeStyles(theme => ({
  optionsButtonRoot: {
    border: ({ disabled }) => (disabled ? 0 : `1px solid var(--border-color-22)`),
    padding: '0 16px 0 8px',
    height: '100%'
  }
}))

const GrinButtonOptionsMenu = ({ options, disabled, OptionMenuItemComponent = GenericOptionMenuItem }) => {
  const classes = useStyles({ disabled })

  const [isOptionsMenuOpen, setIsOptionsMenuOpen] = useState(false)

  const onOptionClicked = useCallback(option => {
    option.onClick()
    setIsOptionsMenuOpen(false)
  }, [])

  const handleOptionsMenuOpen = useCallback(() => {
    setIsOptionsMenuOpen(true)
  }, [])

  const handleOptionsMenuClose = useCallback(() => {
    setIsOptionsMenuOpen(false)
  }, [])

  return (
    <GrinMenu
      onOpen={handleOptionsMenuOpen}
      onClose={handleOptionsMenuClose}
      open={isOptionsMenuOpen}
      transformOrigin={{ vertical: 55, horizontal: 30 }}
      triggerComponent={
        <ButtonBase disabled={disabled} className={[classes.optionsButtonRoot].join(' ')}>
          {isOptionsMenuOpen ? (
            <ArrowDropdownUp color="var(--text-color-1)" />
          ) : (
            <ArrowDropdownDown color="var(--text-color-1)" />
          )}
        </ButtonBase>
      }
    >
      {options.map(option =>
        React.createElement(OptionMenuItemComponent, {
          key: option.id,
          option,
          onClick: () => onOptionClicked(option)
        })
      )}
    </GrinMenu>
  )
}

export default GrinButtonOptionsMenu
